import { api as paymentApi } from './auto-generated/payment'

paymentApi.enhanceEndpoints({
  endpoints: {
    paymentCreateStripeAccount: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled
          dispatch(
            paymentApi.util.updateQueryData('paymentGetStripeAccount', args, (draftAccount) => {
              draftAccount = response.data
            }),
          )
        } catch {}
      },
    },
    paymentCancelUserSubscription: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data } = await queryFulfilled
          patchResult = dispatch(
            paymentApi.util.updateQueryData('paymentGetUserSubscription', args, (draft) => {
              Object.assign(draft, null)
            }),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
  },
})

export { paymentApi }
